import { useSelector } from 'react-redux';
import {companyFeaturesConstants} from '../../constants';
import {useIsIcpTierSmall} from '../feature-flags/useIsIcpTierSmall';

export const ALWAYS_MANDATORY_FIELDS = ['category_tags', 'amount'];

// Small-tier companies don't require an expense description (H1MVP-5047).
const CONDITIONALLY_MANDATORY_FIELDS = ['description'];

const FEATURE_TO_FIELD_MAP = {
  [companyFeaturesConstants.COST_CENTER_TAG_IS_MANDATORY]: 'tags',
  [companyFeaturesConstants.LOCATION_TAG_IS_MANDATORY]: 'location_tags',
  // EXPENSE_TAG_IS_MANDATORY intentionally omitted: category_tags is always mandatory
  [companyFeaturesConstants.PROJECT_TAG_IS_MANDATORY]: 'project_tags',
  [companyFeaturesConstants.GENERIC_EXPENSE_TAG_IS_MANDATORY]: 'generic_expense_tags',
};

// Backward compat: API used to store booleans; true → mandatory, false/null/undefined → not_used.
// Keep in sync with the equivalent normalizeValue in CompanyFeatureSelect.jsx.
export const useTagFieldsByUsage = () => {
  const features = useSelector(state => state.company?.features?.data || []);
  const mandatory = [], optional = [];
  features.forEach(f => {
    const field = FEATURE_TO_FIELD_MAP[f.feature];
    if (!field) return;
    const val = f.value;
    if (val === 'mandatory' || val === true) mandatory.push(field);
    else if (val === 'optional') optional.push(field);
    // 'not_used' / false / undefined → excluded
  });
  return { mandatory, optional };
};

export const useMandatoryExpenseFields = () => {
  const { mandatory } = useTagFieldsByUsage();
  const isIcpTierSmall = useIsIcpTierSmall();
  const conditionallyMandatory = isIcpTierSmall ? [] : CONDITIONALLY_MANDATORY_FIELDS;
  return [...ALWAYS_MANDATORY_FIELDS, ...conditionallyMandatory, ...mandatory];
};

export const useMandatoryTagFields = () => {
  const { mandatory } = useTagFieldsByUsage();
  return mandatory;
};

// Tag fields that are in use (either mandatory or optional), i.e. not 'not_used'.
export const useUsedTagFields = () => {
  const { mandatory, optional } = useTagFieldsByUsage();
  return [...mandatory, ...optional];
};
